import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subscription, forkJoin } from "rxjs";
import { BOFilter } from "../../../models/BOFilter";
import { Router } from "@angular/router";
import { BOItem } from "../../../models/BOItem.model";
import { MatSelectChange } from "@angular/material/select";
import { MatDialog } from "@angular/material/dialog";
import { BOToothOdontograma } from "../../../models/odo/BOToothOdontograma.model";
import { ToothOdontogramaService } from '../../../services/odo/ToothOdontograma.service';
import { CreateOrEditOdontologyHistoryComponent } from "../createOrEditOdontologyHistory.component";
import { ClinicHistoriesPatientComponent } from "../../clinicHistoriesPatient.component";


@Component({
  selector: 'app-odontograma-history',
  templateUrl: './odontograma-history.component.html',
  styleUrls: ['./odontograma-history.component.css']
})
export class OdontogramaHistoryComponent implements OnInit, OnDestroy {
    @ViewChild('createOrEditOdontologyHistoryModal', {static:true}) createOrEditOdontologyHistoryModal: CreateOrEditOdontologyHistoryComponent;
    @ViewChild('clinicHistoriesPatientModal', { static: true }) clinicHistoriesPatientModal: ClinicHistoriesPatientComponent;

  odontogramaList:BOToothOdontograma[]=[]; //odontogramaList
  odontogramaListShort:BOToothOdontograma[]=[]; //odontogramaListShort
  serviceTypeList: BOItem[] = [];

    busy:Subscription;
    odontogramaFilter:string = "";
    data=true;
    selectedArea=0;
    showCreateodontograma:boolean=false;
    showSearchPatient:boolean=false;
    patientName:string="";

  constructor( private _odontogramaHistoryService:ToothOdontogramaService,
               private _router:Router,
               private _toast:ToastrService,
               private _odontogramaService: ToothOdontogramaService
  ) { }



  ngOnInit(): void {
    const filterInput: BOFilter = {filter: this.odontogramaFilter}
    this.busy=this._odontogramaHistoryService.getOdontogramas(filterInput).subscribe(data=>{
      console.log('in ngOnInit of odontogra-history,  data is', data);

      this.odontogramaList=data;
     // this.odontogramaListShort=data;
     this.odontogramaListShort=[...this.odontogramaList];
      console.log('in ngOnInit of odontogra-history,  this.odontogramaListShort is:', this.odontogramaListShort);
    })
  }

    getAllClinicHistories()
    {
        console.log('Entra a getAllClinicHistories');
        this.odontogramaList=[];

        const filterInput: BOFilter = {
            filter: this.odontogramaFilter.toUpperCase().trim()
        }
        this.busy = this._odontogramaHistoryService.getOdontogramas(filterInput)
        .subscribe(data=>{this.odontogramaList = data;
             //Ric
            if(!data.length) this.odontogramaFilter= "";

            if(this.odontogramaList.length>0){
              this.odontogramaListShort=[...this.odontogramaList];
            }
            else{
              this._toast.warning('No existen registros', 'No hay odontogramas');
            }

        });

    }


    
   returnToOdontogramas(): void
    {
      this.odontogramaList=[];
      this.odontogramaListShort=[];

      const filterInput: BOFilter = {
        filter: ""
      }

      this.busy=this._odontogramaHistoryService.getOdontogramas(filterInput).subscribe((data)=>{
        this.odontogramaList=data;

        if(!data.length) this.odontogramaFilter= "";

        if(this.odontogramaList.length>0)
        {
          this.odontogramaListShort=[...this.odontogramaList];
        }

      });

   }

   navigateToOdontogramaFromOdontologyHistory(clinicHistoryId:number, patientId:number){
    //this.toastr.info('data received', 'clinicHistory is:'+clinicHistoryId+ 'patientId is:'+patientId);
    this._router.navigate(['/dental-Admins/odontograma'], {

        queryParams: {
          clinicHistory: clinicHistoryId,
          personId: patientId,
        }
      });
   }


navigateToOdontograma(clinicHistoryId:number, patientId:number, odontoId:number):void
{
        console.log('1Enter to navigateToOdontogramaFromOdontograma');
        console.log('En 1Enter, clinicHistoryId is:', clinicHistoryId, ' and type is: ', typeof clinicHistoryId);
        console.log('En 1Enter, patientId is:', patientId, ' and type is: ', typeof patientId);

        this._router.navigate(['/dental-Admins/odontograma'], {

        queryParams: {
          clinicHistory: clinicHistoryId,
          personId:  patientId,
          odontogramaId:odontoId
        }
      });
}


  ngOnDestroy(): void {
        this.busy?.unsubscribe();
  }
}

    // onAreaSelectionChange(event: MatSelectChange): void
    // {
    //   const selectedValue = event.value;
    //   this.selectedArea=selectedValue;
    //   this.odontogramaListShort=[];

    //   if(this.selectedArea==3)
    //   {
    //     this.odontogramaListShort=[...this.odontogramaList];
    //   }
    //   else
    //   {
    //     let clinicHistoriesFiltered=this.odontogramaList.filter(x=>x.area==this.selectedArea);
    //     this.odontogramaListShort=[...clinicHistoriesFiltered];
    //   }


    // }
